<template>
  <div class="v-switch-button">
    <Feather
      class="v-switch-button__icon"
      type="loader"
      animation="spin"
      v-if="load"
    />
    <label
      v-else
      class="v-switch-button__label"
      :class="{ 'v-switch-button__label--checked': this.checked }"
      @click="onClick"
    />
  </div>
</template>

<script>
import Feather from "vue-feather";

export default {
  name: "VSwitchButton",
  components: {
    Feather
  },
  props: {
    checked: {
      type: [Boolean, Number],
      default: true
    },
    load: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(e) {
      e.stopPropagation();

      this.$emit("click", !this.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-switch-button {
  &__label {
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
    width: 40px;
    height: 20px;
    border-radius: 24px;
    margin: 0 auto;

    &:after,
    &:before {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      content: "";
    }

    &:before {
      background-color: #b0bec5;
      border-radius: 60px;
      transition: all 0.4s;
      width: 100%;
    }

    &:after {
      width: 16px;
      height: 16px;
      top: 50%;
      background-color: #fff;
      border-radius: 100%;
      transition: all 0.4s;
      transform: translateY(-50%);
      left: 2.5px;
    }

    &--checked {
      &:before {
        background-color: #8bc34a;
      }

      &:after {
        left: calc(40px - 3px - 16px);
      }
    }
  }

  &__icon {
    color: #90a4ae;
    width: 24px;
    margin: 0 auto;
    display: block;
    svg {
      stroke-width: 3.4;
    }
  }
}
</style>
